import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { UtsavaSpanEnrichment } from "./UtsavaEnrichment";

/** Mini list of multi-day utsavas below daily summary. */
export function UtsavaListMini({ spans }) {
  if (!spans?.length) return null;

  return (
    <div className="mt-4 pt-4 border-t border-border/40" data-testid="dashboard-utsava-month">
      <p className="text-sm font-medium mb-2">Utsava This Month</p>
      <Accordion type="single" collapsible className="w-full">
        {spans.map((span) => (
          <AccordionItem key={`${span.id}-${span.startIndex}`} value={`${span.id}-${span.startIndex}`}>
            <AccordionTrigger className="text-sm py-2 hover:no-underline">
              <span>
                {span.name} — <span className="text-muted-foreground font-normal">{span.dateRange}</span>
              </span>
            </AccordionTrigger>
            <AccordionContent>
              <UtsavaSpanEnrichment sourceDay={span.sourceDay} />
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
